/* SIGHTSS — publishes two measurements as CSS variables.

   --sightss-above-hero   how much sits ABOVE the hero (the announcement bar),
                          so the hero can be sized to exactly the rest of the
                          screen. A floating header overlaps the hero and is
                          therefore correctly not counted here.

   --sightss-hdr-clear    how far the floating header reaches DOWN INTO the
                          hero. Measured as the union of the header's visible
                          children (the pill), not the header element itself:
                          the element can be shorter than the pill it holds,
                          which earlier produced a value smaller than reality.
                          The CSS also applies a floor, so a bad reading can
                          never push the headline behind the header.          */
(function () {
  var ABOVE = '--sightss-above-hero';
  var CLEAR = '--sightss-hdr-clear';
  var GAP = 16;

  function hero() {
    return document.querySelector('.sightss-slider');
  }

  function headerEl() {
    return (
      document.querySelector('header-component') ||
      document.querySelector('#header-component') ||
      document.querySelector('.header-section') ||
      document.getElementById('header-group')
    );
  }

  /* Height of everything visibly rendered inside the header: the union of
     the element's own box and its descendants two levels deep. */
  function visibleHeight(el) {
    var top = Infinity, bottom = -Infinity;
    function take(node) {
      if (!node || !node.getBoundingClientRect) return;
      var r = node.getBoundingClientRect();
      if (r.height <= 0 || r.width <= 0) return;
      if (r.top < top) top = r.top;
      if (r.bottom > bottom) bottom = r.bottom;
    }
    take(el);
    var kids = el.children || [];
    for (var i = 0; i < kids.length; i++) {
      take(kids[i]);
      var grand = kids[i].children || [];
      for (var j = 0; j < grand.length; j++) take(grand[j]);
    }
    return isFinite(top) && isFinite(bottom) ? bottom - top : 0;
  }

  function measure() {
    var root = document.documentElement.style;
    var h = hero();

    if (h) {
      var t = h.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
      if (isFinite(t)) root.setProperty(ABOVE, Math.max(0, Math.round(t)) + 'px');
    }

    var hdr = headerEl();
    if (!hdr) return;

    var height = visibleHeight(hdr);
    if (!isFinite(height) || height <= 0) return;

    var clear = Math.round(height) + GAP;
    clear = Math.min(clear, Math.round(window.innerHeight * 0.4));
    root.setProperty(CLEAR, clear + 'px');
  }

  var frame = null;
  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      frame = null;
      measure();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(schedule).catch(function () {});
  }

  [120, 350, 800, 1600].forEach(function (ms) {
    setTimeout(schedule, ms);
  });

  if (window.ResizeObserver) {
    var group = document.getElementById('header-group');
    if (group) new ResizeObserver(schedule).observe(group);
    var h2 = hero();
    if (h2) new ResizeObserver(schedule).observe(h2);
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  document.addEventListener('shopify:section:select', schedule);
})();